import script from "./Application.vue?vue&type=script&setup=true&lang=ts"
export * from "./Application.vue?vue&type=script&setup=true&lang=ts"

import "./Application.vue?vue&type=style&index=0&id=444e9aab&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-444e9aab"]])

export default __exports__